const API_BASE = process.env.REACT_APP_API_URL || "http://127.0.0.1:8000";
const _cache = new Map();

export async function fetchPlaceSuggestions(input) {
  const trimmed = input.trim();
  if (trimmed.length < 2) return [];

  if (_cache.has(trimmed)) return _cache.get(trimmed);

  try {
    const res = await fetch(
      `${API_BASE}/places/autocomplete?input=${encodeURIComponent(trimmed)}`
    );
    if (!res.ok) return [];
    const data = await res.json();
    const suggestions = data.suggestions || [];
    if (suggestions.length) _cache.set(trimmed, suggestions);
    return suggestions;
  } catch {
    return [];
  }
}
